/**
 * TicketID login UX (aligned with WordPress TicketConnect):
 * - clamp serial to 6 digits
 * - move focus to the key field when 6 digits are entered
 * - clamp key to 6 characters
 * - pasting "123456 - abcdef" fills both fields (before maxlength truncates)
 */
(function ($) {
    'use strict';

    // Printed TicketID: 6 digits, optional dash, 6-character key.
    var PASTED_TICKET_ID = /^\s*(\d{6})\s*[-–—]?\s*([a-z0-9]{6})\s*$/i;

    if (window.tktTicketidLoginBound) {
        return;
    }
    window.tktTicketidLoginBound = true;

    function set_value(input, value) {
        if (input.value === value) {
            return value;
        }
        input.value = value;
        // Keep Angular ng-model (map booking) in sync when we clamp.
        $(input).trigger('input');
        return value;
    }

    function clamp_number(input) {
        return set_value(input, String(input.value || '').replace(/\D/g, '').slice(0, 6));
    }

    function clamp_key(input) {
        return set_value(input, String(input.value || '').slice(0, 6));
    }

    function split_pasted_ticket_id(raw) {
        var match = String(raw || '').match(PASTED_TICKET_ID);
        if (!match) {
            return null;
        }
        return { number: match[1], key: match[2] };
    }

    $(document).on('paste', '.ticket-auth-stack .ticketid-number-input, .ticket-auth-stack .ticketid-key-input', function (e) {
        var clipboard = e.originalEvent && e.originalEvent.clipboardData;
        var parts = split_pasted_ticket_id(clipboard ? clipboard.getData('text') : '');
        if (!parts) {
            return;
        }
        e.preventDefault();
        var $stack = $(this).closest('.ticket-auth-stack');
        var number = $stack.find('.ticketid-number-input').get(0);
        var key = $stack.find('.ticketid-key-input').get(0);
        if (number) {
            set_value(number, parts.number);
        }
        if (key) {
            set_value(key, parts.key);
            key.focus();
        }
    });

    $(document).on('input keyup', '.ticket-auth-stack .ticketid-number-input', function () {
        var digits = clamp_number(this);
        if (digits.length >= 6) {
            $(this).closest('.ticket-auth-stack').find('.ticketid-key-input').first().focus();
        }
    });

    $(document).on('input', '.ticket-auth-stack .ticketid-key-input', function () {
        clamp_key(this);
    });
}(jQuery));
